import { useNavigate } from "react-router-dom";
import { Eye, Loader2 } from "lucide-react";
import getImageUrl from "../../../utils/imageUrl";
import "./FoodTable.css";

function FoodTable({
    foods,
    loading,
}) {

    const navigate = useNavigate();

    if (loading) {
        return (
            <div className="loading-state">
                <Loader2
                    size={42}
                    className="spin"
                />
                <p>Loading Foods...</p>
            </div>
        );
    }

    if (foods.length === 0) {
        return (
            <div className="empty-state">
                <h3>No Foods Found</h3>
                <p>No food items available.</p>
            </div>
        );
    }

    return (
        <div className="food-table-wrapper">

            <table className="food-table">

                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Food</th>
                        <th>Provider</th>
                        <th>Category</th>
                        <th>Type</th>
                        <th>Price</th>
                        <th>Offer Price</th>
                        <th>Rating</th>
                        <th>Orders</th>
                        <th>Status</th>
                        <th>Highlights</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>

                    {foods.map((food) => (

                        <tr key={food._id}>

                            <td>
                              <img
    src={
        food.image
            ? getImageUrl(food.image)
            : "/food-placeholder.png"
    }
    alt={food.foodName || "Food"}
    className="food-image"
    onError={(event) => {
        event.currentTarget.src =
            "/food-placeholder.png";
    }}
/>
                            </td>

                            <td>
                                <div className="food-info">
                                    <strong>{food.foodName}</strong>
                                    <small>
                                        ⏱ {food.preparationTime} mins
                                    </small>
                                </div>
                            </td>

                            <td>
                                {food.providerId?.businessName || "-"}
                            </td>

                            <td>
                                {food.category}
                            </td>

                            <td>
                                <span
                                    className={
                                        food.foodType === "Veg"
                                            ? "veg-badge"
                                            : "nonveg-badge"
                                    }
                                >
                                    {food.foodType}
                                </span>
                            </td>

                            <td>
                                ₹{food.price}
                            </td>

                            <td>
                                {food.offerPrice > 0
                                    ? `₹${food.offerPrice}`
                                    : "-"}
                            </td>

                            <td>
                                ⭐ {food.rating || 0}
                            </td>

                            <td>
                                {food.totalOrders || 0}
                            </td>

                            <td>
                                <span
                                    className={
                                        food.isAvailable
                                            ? "status-active"
                                            : "status-inactive"
                                    }
                                >
                                    {food.isAvailable
                                        ? "Available"
                                        : "Unavailable"}
                                </span>
                            </td>

                            <td>

                                <div className="highlight-badges">

                                    {food.isFeatured && (
                                        <span className="featured">
                                            Featured
                                        </span>
                                    )}

                                    {food.isBestSeller && (
                                        <span className="best">
                                            Best Seller
                                        </span>
                                    )}

                                    {food.isTodaysSpecial && (
                                        <span className="special">
                                            Today
                                        </span>
                                    )}

                                </div>

                            </td>

                            <td>

                                <button
                                    className="details-btn"
                                    onClick={() =>
                                        navigate(`/admin/foods/${food._id}`)
                                    }
                                >
                                    <Eye size={18} />
                                    <span>View Details</span>
                                </button>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
}

export default FoodTable;